import { FleekError } from './FleekError';

export class PrivateGatewaysNotFoundError extends FleekError<Record<string, never>> {
  public name = 'PrivateGatewaysNotFoundError';

  toString = () => 'No private gateways found.';
}
